module.exports = __webpack_public_path__ + "img/iot-scene-hazard.bc05867b.png";